import * as v from "valibot"

const pluralizeEn = (count: number, singular: string, plural: string) => {
    return `${count} ${count === 1 ? singular : plural}`;
};

const asNumber = (value: unknown) => {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "bigint") {
        return Number(value);
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? undefined : parsed;
};

v.setGlobalMessage(() => "Invalid value", "en");

v.setSpecificMessage(v.string, () => "Please fill in this field", "en");
v.setSpecificMessage(v.number, () => "Enter a number", "en");
v.setSpecificMessage(v.integer, () => "Enter an integer", "en");
v.setSpecificMessage(v.safeInteger, () => "Enter a safe integer", "en");
v.setSpecificMessage(v.boolean, () => "Please select", "en");
v.setSpecificMessage(v.bigint, () => "Enter a number", "en");
v.setSpecificMessage(v.date, () => "Enter a valid date", "en");

v.setSpecificMessage(v.email, () => "Enter a valid email", "en");
v.setSpecificMessage(v.url, () => "Enter a valid URL", "en");
v.setSpecificMessage(v.regex, () => "Invalid format", "en");
v.setSpecificMessage(v.nonEmpty, () => "Field must not be empty", "en");

v.setSpecificMessage(
    v.minLength,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Enter at least ${pluralizeEn(requirement, "character", "characters")}`;
    },
    "en"
);

v.setSpecificMessage(
    v.maxLength,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Enter at most ${pluralizeEn(requirement, "character", "characters")}`;
    },
    "en"
);

v.setSpecificMessage(
    v.minValue,
    (issue) => {
        const requirement = issue.requirement;
        return `Enter a value ≥ ${requirement}`;
    },
    "en"
);

v.setSpecificMessage(
    v.maxValue,
    (issue) => {
        const requirement = issue.requirement;
        return `Enter a value ≤ ${requirement}`;
    },
    "en"
);


v.setSpecificMessage(v.array, () => "Select at least one item", "en");
v.setSpecificMessage(v.object, () => "Fill in the required fields", "en");

v.setSpecificMessage(
    v.minSize,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Select at least ${pluralizeEn(requirement, "item", "items")}`;
    },
    "en"
);

v.setSpecificMessage(
    v.maxSize,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Select at most ${pluralizeEn(requirement, "item", "items")}`;
    },
    "en"
);

v.setSpecificMessage(v.literal, (issue) => `Allowed value is ${String(issue.requirement)}`, "en");
v.setSpecificMessage(v.enum, () => "Select one of the offered options", "en");

v.setGlobalConfig({ lang: "en" });
